var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideoVolumeOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 25.003,
  height: 25.003,
  fill: "#454A4A",
  fillOpacity: 0.7,
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FAFDFF",
  fillRule: "evenodd",
  d: "M6.038 6.71c.26-.26.68-.26.94 0l11.327 11.333a.664.664 0 1 1-.94.94l-4.86-4.86v2.966c0 .567-.66.874-1.094.514l-2.906-2.42H7.17c-.733 0-1.333-.6-1.333-1.334v-2.667c0-.733.6-1.333 1.333-1.333h1.06l-2.193-2.2a.664.664 0 0 1 0-.94m5.373.72a.667.667 0 0 1 1.094.513v2.413L10.41 8.262zm2.88 3.84c.527.18.88.68.88 1.246 0 .153-.026.293-.073.433l.993.994c.26-.414.42-.907.42-1.42 0-1.14-.72-2.147-1.786-2.514a.67.67 0 0 0-.847.413c-.12.347.06.727.413.847m3.547 1.246c0-1.434-.767-2.76-2.007-3.46a.666.666 0 0 1 .654-1.16 5.3 5.3 0 0 1 1.506 7.946l-.947-.946a3.96 3.96 0 0 0 .794-2.38",
  clipRule: "evenodd"
})));
export default SvgVideoVolumeOff;